export default {
      id: "ic_bell_selected_white-usage",
      viewBox: "0 0 18 20",
      url: "/" + "images/icons.3.109.2.svg#ic_bell_selected_white-usage",
      toString: function () {
        return this.url;
      }
    }